import { Component, OnDestroy } from "@angular/core";
import { Account } from "@app/pendo/interfaces/pendo.interfaces";
import { PendoService } from "@app/pendo/pendo.service";
import { CustomPromotionPendoFacadeService } from "@kehe/custom-promotions-lib";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

// Key created in custom-promotions-lib
const LIST_FILTER_STORE_KEY = "listFilterStoreState";

@Component({
  selector: "app-custom-promotions-page",
  templateUrl: "./custom-promotions-page.component.html",
  standalone: false,
})
export class CustomPromotionsPageComponent implements OnDestroy {
  private destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    sessionStorage.removeItem(LIST_FILTER_STORE_KEY);
    this.destroy$.next();
    this.destroy$.complete();
  }

  constructor(
    private _pendoFacade: CustomPromotionPendoFacadeService,
    private _pendoService: PendoService,
  ) {
    this._pendoFacade.trackEvent
      .pipe(takeUntil(this.destroy$))
      .subscribe((event) => {
        this._pendoService.trackEvent(event.eventName, event.eventProperties);
      });
    this._pendoFacade.updateAccount
      .pipe(takeUntil(this.destroy$))
      .subscribe((event) => {
        this._pendoService.updateAccount(
          event.updatedAccount as unknown as Account,
        );
      });
  }
}
